import React, { FC } from 'react'
import { Fab, useTheme, Collapse } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import ReactDOM from 'react-dom'
import { ALERT_WRAPPER_ZINDEX } from '../../constants'
import { useAlert } from '../../hooks'
import { CommonTipItem } from './Tips'

export const AlertContainer: FC = () => {
  const theme = useTheme()

  const { resetAlertData, alertData } = useAlert()

  const colorMap = {
    primary: 'rgba(39, 110, 241, 0.2)',
    warning: 'rgba(239, 40, 40, 0.2)',
    danger: 'rgba(239, 128, 25, 0.2)',
    success: 'rgba(25, 182, 97, 0.2)',
  }

  return ReactDOM.createPortal(
    <Collapse
      in={Boolean(alertData)}
      unmountOnExit
      sx={{
        zIndex: ALERT_WRAPPER_ZINDEX,
        maxWidth: '90%',
        width: 'max-content',
        border: '1px solid',
        position: 'fixed',
        left: '50%',
        transform: 'translateX(-50%)',
        top: theme.spacing(1.5),
        backgroundColor: '#fff',
        '& div': {
          padding: 0,
        },
        '& > div': {
          padding: theme.spacing(0.5, 6, 0.5, 1),
        },
        borderColor: alertData?.type ? colorMap[alertData.type] : 'transparent',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
      }}
    >
      <CommonTipItem
        value={alertData?.text || ''}
        iconComponent={alertData?.icon || null}
        valueBold={alertData?.textBold}
        title={alertData?.title}
      />
      <Fab
        disableRipple
        sx={{
          position: 'absolute',
          top: 3,
          right: theme.spacing(1),
          backgroundColor: 'transparent',
          boxShadow: 'none',
          height: 32,
          width: 32,
          minHeight: 32,
          '&:hover': {
            backgroundColor: '#F5F5F5',
          },
          '& .MuiSvgIcon-root': {
            height: 16,
            width: 16,
          },
        }}
        onClick={resetAlertData}
      >
        <CloseIcon />
      </Fab>
    </Collapse>,
    document.body,
  )
}
